module.exports = __webpack_public_path__ + "media/images/Arrow-ios-back-fill-6f70d464.svg";